import {
  determineIsTemplateVisibleToUser,
  mapInventoryTemplate,
} from './helpers';

type PrepTemplatesForTable = {
  inventoryTemplates?: InventoryTopology[];
  userRoles?: UserRole[];
};

export const prepTemplatesForTable = ({
  inventoryTemplates,
  userRoles,
}: PrepTemplatesForTable): InventoryTopology[] => {
  if (!inventoryTemplates) {
    return [];
  }

  return inventoryTemplates
    .filter((inventoryTemplate) =>
      determineIsTemplateVisibleToUser(inventoryTemplate, userRoles),
    )
    .map(mapInventoryTemplate);
};
